 import React from "react";
 import "./About.css";

 function About(){
    return (
        <div className="about">
            <div className="mouse-svg-container">
                    <img className="mouse" src='/Assets/keyboard.png' alt="mouse"></img>
                </div>
            
            <div className="about-left-container">
                <div className="about-left">
                    <span className="about-left-span-1">I'm a web developer,<br></br>
                    UI/UX designer,<br></br> and programmer.</span><br></br>
                    <span className="about-left-span-2">I excel at crafting clean UI<br></br> 
                    and solving real-world <br></br>problems with my skills.</span>
                </div>
            </div>
            <div className="keyboard-svg-container">
                    <img className="keyboard-img" src="/Assets/earphone.png" alt="earphone"></img>
            </div>
            <div className="about-right-container">
                <div className="about-right">
                    <span className="about-right-span-1">And yeah!!</span><br></br>
                    <span className="about-right-span-2">I also do <br></br>android development,<br></br>
                    and wanna explore <br></br>artificial inteligence :)</span>
                </div>
            </div>
        </div>
    );
 }

 export default About;